/** Registers the Polygon2D parser and property formatter. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parsePolygon2D } from './parser';
import { formatPolygon2DProperties } from './propertyFormatter';
const polygon2DRegistration = {
    typeName: 'Polygon2D',
    parser: parsePolygon2D,
    propertyFormatter: formatPolygon2DProperties,
};
nodeRegistry.register(polygon2DRegistration);
export * from './parser';
export * from './propertyFormatter';
export * from './types';
//# sourceMappingURL=index.js.map